import React, { useCallback } from 'react';

import { MetaTags } from '@ergeon/core-components';

import { WIKI_TITLE } from './constants';

const getTitle = (pageTitle?: string) => {
  if (!pageTitle) {
    return WIKI_TITLE;
  }
  return `${pageTitle} | ${WIKI_TITLE}`;
};

const WikiMeta = ({ pageTitle }: { pageTitle?: string }) => {
  const getMeta = useCallback(async() => ({ description: '', title: getTitle(pageTitle) }), [pageTitle]);

  return <MetaTags getMeta={getMeta} />;
};

export default WikiMeta;
